/**
 * The groups of customers slp.blue serves, in display order. The visitor picks
 * one at the top of the home page and the page adapts to it. Each one's title,
 * plus an optional list of `specialties` shown with our customers, live under
 * `useCases.items.<key>` in every locale; adding a use case means adding its
 * key and path here, its translations, and its path to scripts/prerender.js.
 */
export type UseCase = 'clinical' | 'transfusion' | 'testing' | 'hospitalQms';

export const useCases: UseCase[] = ['clinical', 'transfusion', 'testing', 'hospitalQms'];

/** Shown on the plain home page ('/', '/en'). */
export const DEFAULT_USE_CASE: UseCase = 'clinical';

/** Home page variant of each use case, e.g. '/testing' and '/en/testing'. */
export const USE_CASE_PATHS: Record<UseCase, string> = {
  clinical: '/clinical',
  transfusion: '/transfusion',
  testing: '/testing',
  hospitalQms: '/hospital',
};

/** Use cases working with laboratory methods and their verification. */
export const hasMethodVerification = (useCase: UseCase): boolean => useCase === 'clinical' || useCase === 'transfusion';

/** Use cases the IKEM training of laboratory users is advertised to. */
export const hasIkemTraining = (useCase: UseCase): boolean => useCase === 'clinical' || useCase === 'transfusion';

/**
 * What the documents published from slp.blue are called for each use case: the
 * laboratory handbook, the hospital intranet, or nothing for testing laboratories.
 */
export const PUBLISHED_WEB: Record<UseCase, 'handbook' | 'intranet' | undefined> = {
  clinical: 'handbook',
  transfusion: 'handbook',
  testing: undefined,
  hospitalQms: 'intranet',
};
